import { messagesNow } from '@/i18n'
import { messages } from './messages'

/**
 * Тексты кодов возобновления (§8) — общая таблица на ДВУХ потребителей, а не
 * только на подсказку. Первый — `hint.reason` в подсказке поллинга
 * (`ResumeAction`): объясняет, почему кнопки нет или почему клик по ней
 * заведомо не пройдёт. Второй — `businessView` (`failureText.ts`): ручка
 * `POST .../resume` сама умеет ответить `422` с ЭТИМ ЖЕ кодом (например,
 * `studio_job_in_progress` — защитная ветка `_reject` в
 * `studio_ai.py:1646`, HTTP 422, а не привычный 409 «занято»), и тогда текст
 * идёт в красную строку отказа клика, а не в серую подсказку. Один код может
 * оказаться на двух путях С РАЗНЫМИ текстами одновременно — это не ошибка:
 * `course_busy` (409, «Курс занят прогоном #45») и это 422-ответ той же
 * ручки — разные ситуации, и тексты обязаны звучать уместно каждый в своём
 * месте, а не совпадать дословно. Раньше отсюда исключались
 * `image_style_required`, `not_enough_ai_credits`, `studio_job_in_progress`,
 * `n8n_unavailable` и `already_resumed` одним списком, с мотивировкой «у них
 * своё действие, разбирает `parseStartError`» — это верно только для тех их
 * статусов, где `parseStartError` даёт отдельный `kind` (400 → `no_credits`,
 * 409 → `course_busy`/`already_resumed`, 503 → `not_configured`), но не
 * покрывает ни `hint.reason`, ни собственный `422` ручки возобновления —
 * оба доходят именно до этой таблицы (финальное ревью раунд 4, Important;
 * раунд 5 — уточнение про второго потребителя).
 *
 * `image_style_required` по-прежнему сюда НЕ входит: вызывающий
 * (`ResumeAction`) сначала спрашивает эту таблицу, а когда она отвечает
 * `null` — общий `businessView`, который уже знает этот код через
 * `imageFailureText`. Заводить его здесь второй копией — плодить
 * рассинхронизацию текста при следующей правке `imageFailureText`.
 */
export const resumeFailureText = (code: string, message: string): string | null => {
  const m = messagesNow(messages)
  switch (code) {
    case 'nothing_to_resume':
      return m.nothingToResume
    case 'run_did_not_start':
      return m.runDidNotStart
    case 'generation_plan_not_saved':
      return m.generationPlanNotSaved
    case 'job_type_not_resumable':
      return m.jobTypeNotResumable
    case 'job_not_yours':
      return m.jobNotYours
    case 'not_enough_ai_credits':
      return m.resumeNoCredits
    case 'studio_job_in_progress':
      return m.resumeJobInProgress
    case 'n8n_unavailable':
      return m.resumeN8nUnavailable
    case 'already_resumed':
      // Срабатывает только когда `hint.job_id` пуст (данные с бэка сами по
      // себе противоречивы — §8 обещает его непустым при этом коде):
      // `buttonKind` (`ResumeAction.tsx`) в этом случае падает не в
      // «Показать продолжение», а в «Попробовать снова», и текст берёт
      // отсюда, а не из соседней константы `ALREADY_RESUMED_TEXT`
      // (та — для случая с `job_id`, где кнопка сразу ведёт на продолжение).
      // Без совета «обновить страницу»: сама «Попробовать снова» уже делает
      // нужное — клик уходит в ручку, ловит `409` с `job_id` продолжения и
      // перецепляет поллинг сам, без перезагрузки (финальное ревью раунд 5).
      return m.resumeAlreadyResumed
    default:
      // Незнакомый код: пусть вызывающий покажет серверный `message`, а не
      // выдуманный нами диагноз.
      void message
      return null
  }
}
